import { Card, Col, InputNumber, Row, Space } from 'antd';
import FormItem from 'components/form/FormItem';
import FormSwitch from 'components/form/FormSwitch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { inputNumberFormatter } from 'utils/formattedString';

const Form = () => {
  const { t } = useTranslation();
  return (
    <Row gutter={[20, 20]} className="mt-3">
      <Col md={15} xs={24}>
        <Space size={20} direction="vertical" className="w-full">
          <Card title={t('chainStores.generalInformation')}>
            <FormItem required name="name" label="chainStores.name" />
            <FormItem required name="secretKey" label="chainStores.secretKey" />
            <FormItem required name="prefix" label="chainStores.prefix" />
            <FormItem
              ruleType="number"
              name="priority"
              label="chainStores.priority"
            >
              <InputNumber {...inputNumberFormatter()} min={0} />
            </FormItem>
          </Card>
          <Card title={t('chainStores.companyData')} className="w-full">
            <FormItem required name="logo" label="chainStores.logo" />
            <FormItem required name="siteUrl" label="chainStores.siteUrl" />
            <FormItem
              required
              name="companyName"
              rootName="data"
              label="chainStores.companyName"
            />
            <FormItem
              required
              name="address"
              label="chainStores.address"
              rootName="data"
            />
            <FormItem
              required
              name="email"
              label="chainStores.email"
              rootName="data"
            />
            <FormItem
              required
              name="phoneNumber"
              label="chainStores.phoneNumber"
              rootName="data"
            />
            <FormItem
              required
              name="hotline"
              label="chainStores.hotline"
              rootName="data"
            />
          </Card>
        </Space>
      </Col>
      <Col md={9} xs={24}>
        <Space size={20} direction="vertical" className="w-full">
          <Card title={t('chainStores.status')}>
            <FormSwitch
              valuePropName="checked"
              name="isActive"
              label="chainStores.isActive"
            />
          </Card>
        </Space>
      </Col>
    </Row>
  );
};

export default Form;
